"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToOthers = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var crokinoleMultiplayerCursors_sidecar_1 = require("@crokinole/cursors/crokinoleMultiplayerCursors-sidecar");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageMessageIds_1 = require("@voyage/multi/voyageMessageIds");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Crokinole_Cursor;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.x);
    messageWriter_sidecar_1.messageWriter.write16(m, d.y);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        x: messageWriter_sidecar_1.messageWriter.read16(m),
        y: messageWriter_sidecar_1.messageWriter.read16(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        x: 120,
        y: 110,
    };
    messageWriter_sidecar_1.messageWriter.test('cursor', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    var msg = read(m);
    var cur = crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.findByMultiIdSafe(fromId);
    if (cur) {
        crokinoleMultiplayerCursors_sidecar_1.crokinoleMultiplayerCursors.networkRecieveStartLerpToXY(cur, msg.x, msg.y);
    }
    else {
        console.warn('process', 'no cursor', fromId);
    }
}
exports.process = process;
function sendMessageToOthers(msg) {
    websockets_sidecar_1.websockets._sendMessageToOthers(write, msg);
}
exports.sendMessageToOthers = sendMessageToOthers;
